/**
 * H5调起付费Hybrid协议。
 * @param {Object} opt 参数对象
 * @param {String} opt.transaction_id 流水ID
 * @param {Number} opt.pay_type 支付类型，1：kkb支付；2：人民币支付
 * @param {Object} opt.track_data 客户端埋点
 * @param {Function} opt.callback 回调函数
 * @param {Number} criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置）
 */
function native_pay (opt, criticalAppVersion) {

    var param = {};
    var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion)

    if (allow) {
        param = {
            schema: 'kkmhhybrid',
            tagname: 'native_pay'
        }
    } else {
        param = {
            schema: 'kkhybrid',
            tagname: 'nativePay'
        }
    }
    hybrid({
        hybridParam: param,
        param: {
            transaction_id: opt.transaction_id,
            pay_type: opt.pay_type || 1,
            track_data: opt.track_data || {}
        },
        callback: function (res) {
            opt.callback && opt.callback(res);
        }
    });
}

export default native_pay;


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/native_pay/index.js